export default [
  {
    name: 'index', // 和pages下的目录名称一样
    title: '索引页面'
  }, {// 上海云
    name: 'center_homepage_demand',
    title: '需求中心'
  }, {
    name: 'center_homepage_supply',
    title: '供给中心'
  }, {
    name: 'center_search_product',
    title: '搜索结果'
  }, {
    name: 'center_search_purchaseinfo',
    title: '搜索结果'
  }, {
    name: 'center_detail',
    title: '交易中心'
  }, { // 江西云
    name: 'jiangxi_homepage_demand',
    title: '需求中心'
  }, {
    name: 'jiangxi_homepage_supply',
    title: '供给中心'
  }, {
    name: 'jiangxi_search_product',
    title: '搜索结果'
  }, {
    name: 'jiangxi_search_purchaseinfo',
    title: '搜索结果'
  }, {
    name: 'jiangxi_detail',
    title: '江西云'
  }, { // 湖北云
    name: 'hubei_homepage_demand',
    title: '需求中心'
  }, {
    name: 'hubei_homepage_supply',
    title: '供给中心'
  }, {
    name: 'hubei_search_product',
    title: '搜索结果'
  }, {
    name: 'hubei_search_purchaseinfo',
    title: '搜索结果'
  }, {
    name: 'hubei_detail',
    title: '湖北云'
  }, { // 湖南云
    name: 'hunan_homepage_demand',
    title: '需求中心'
  }, {
    name: 'hunan_homepage_supply',
    title: '供给中心'
  }, {
    name: 'hunan_search_product',
    title: '搜索结果'
  }, {
    name: 'hunan_search_purchaseinfo',
    title: '搜索结果'
  }, {
    name: 'hunan_detail',
    title: '湖南云'
  }, { // 浙江云
    name: 'zhejiang_homepage_demand',
    title: '需求中心'
  }, {
    name: 'zhejiang_homepage_supply',
    title: '供给中心'
  }, {
    name: 'zhejiang_search_product',
    title: '搜索结果'
  }, {
    name: 'zhejiang_search_purchaseinfo',
    title: '搜索结果'
  }, {
    name: 'zhejiang_detail',
    title: '浙江云'
  }, { // 贵州云
    name: 'guizhou_homepage_demand',
    title: '需求中心'
  }, {
    name: 'guizhou_homepage_supply',
    title: '供给中心'
  }, {
    name: 'guizhou_search_product',
    title: '搜索结果'
  }, {
    name: 'guizhou_search_purchaseinfo',
    title: '搜索结果'
  }, {
    name: 'guizhou_detail',
    title: '贵州云'
  }, { // 重庆云
    name: 'chongqing_homepage_demand',
    title: '需求中心'
  }, {
    name: 'chongqing_homepage_supply',
    title: '供给中心'
  }, {
    name: 'chongqing_search_product',
    title: '搜索结果'
  }, {
    name: 'chongqing_search_purchaseinfo',
    title: '搜索结果'
  }, {
    name: 'chongqing_detail',
    title: '重庆云'
  }
]



// WEBPACK FOOTER //
// ./src/configs/views.js